import React, { useState, useContext } from 'react';
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';
import iqd_rounding from '../../../utils/iqd_rounding';
import { FiAlertTriangle, FiArrowDownLeft, FiArrowUpRight, FiDollarSign, FiPackage, FiRefreshCw, FiShoppingBag, FiTool, FiTrendingDown, FiTrendingUp, FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";
import { AiOutlineDollar } from "react-icons/ai";
import { MdOutlineBrokenImage, MdOutlineMoneyOff } from "react-icons/md";
import Profit_detail_table_modal from './profit_detail_table_modal';

const Summary_table = () => {
    const { initState } = useContext(GlobalContext);

    const [profitdetail_array, setprofitdetail_array] = useState([]);
    const [show, setshow] = useState(false);

    // Helper to determine if a value is negative
    const isNegative = (val) => money_rounding(val) < 0;
    const amount = value => Number(value) || 0;
    const money = value => `${numberbeautify(money_rounding(amount(value)))} $`;

    const Metric = ({ icon: Icon, label, value, tone = "slate", detail }) => (
        <div className="flex items-center justify-between gap-4 rounded-xl border border-slate-100 bg-white p-4 shadow-sm">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${tone === "green" ? "bg-emerald-50 text-emerald-600" : tone === "red" ? "bg-rose-50 text-rose-600" : "bg-slate-100 text-slate-500"}`}>
            <Icon size={19} />
        </div>
        <div className="min-w-0 flex-1 text-right">
            <p className="text-xs font-medium text-slate-400">{label}</p>
            <p className="mt-1 text-sm font-semibold text-slate-800">{value}</p>
            {detail && <p className="mt-1 text-xs text-slate-400">{detail}</p>}
        </div>
        </div>
    );
    const Section = ({ title, icon: Icon, children, tone }) => (
        <section className="rounded-xl border border-slate-100 bg-white shadow-sm">
            <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-4 text-right">
                <div className={`rounded-lg p-2 ${tone === "green" ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
                    <Icon size={17} />
                </div>
                <h2 className="flex-1 text-sm font-semibold text-slate-700">{title}</h2>
            </div>
            <div className="divide-y divide-slate-50">{children}</div>
        </section>
    );

    const Line = ({ icon: Icon, label, value, detail, detail2, cursor, onClick }) => (
        <div className={`flex items-center justify-between gap-4 px-5 py-4 text-right ${cursor&&'cursor-pointer'}`} onClick={onClick}>
            <div className="flex min-w-0 items-center gap-3">
                {Icon && <Icon className="shrink-0 text-slate-400" size={19} />}
                <div>
                <p className="text-sm font-medium text-slate-700">{label}</p>
                {detail && <p className="mt-1 text-xs text-slate-400">{detail}</p>}
                </div>
            </div>
            <div>
                <p className="shrink-0 text-sm font-semibold text-slate-800">{value}</p>
                {detail2 && <p className="mt-1 text-xs text-slate-400 line-through">{detail2}</p>}
            </div>
        </div>
    );

    return (
        <div className="space-y-6 mt-6" dir="rtl">
            <Profit_detail_table_modal 
                show={show} 
                setshow={setshow} 
                profitdetail_array={profitdetail_array} 
            />
            <div className={`rounded-2xl p-6 text-white shadow-sm ${Number(initState?.summary_report_total_save)>=0 ? "bg-emerald-600" : "bg-rose-600"}`}>
                <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    <p className="text-sm font-medium text-white/75">پوختەی قاسە</p>
                    <h2 className="mt-2 text-3xl font-bold tracking-tight">{money(initState?.summary_report_total_save)}</h2>
                    <p className="mt-2 text-sm text-white/75">داهات - خەرجییەکان</p>
                </div>
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15">
                    {Number(initState?.summary_report_total_save)>=0 ? <FiTrendingUp size={27} /> : <FiTrendingDown size={27} />}
                </div>
                </div>
            </div>
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <Section title="داهاتەکان" icon={FiTrendingUp} tone="green">
                    <Line icon={FiShoppingBag} label="فرۆش" value={money(initState?.summary_report_total_sell)}/>
                    <Line icon={AiOutlineDollar} label="قازانج" value={money(initState?.summary_report_total_profit)} detail={'کلیک بکە بۆ وردەکاری قازانج'} cursor={true} onClick={() => {
                            setprofitdetail_array(initState?.profitdetail_array);
                            setshow(true);
                        }}/>
                    <Line icon={FiArrowDownCircle} label="قەرزی گەڕاوە" value={money(initState?.summary_report_total_loan_in)}/>
                </Section>
                <Section title="کەمکردنەوەکان" icon={FiTrendingDown} tone="red">
                    <Line icon={MdOutlineBrokenImage} label="خەسار" value={money(initState?.summary_report_total_broke)}/>
                    <Line icon={MdOutlineMoneyOff} label="خەرجی" value={money(initState?.summary_report_total_expense)}/>
                    <Line icon={FiArrowUpCircle} label="قەرزی دراوە" value={numberbeautify(money_rounding(amount(initState?.summary_report_total_loan_out)))}/>
                </Section>
            </div>
            <section className="rounded-xl border border-slate-100 bg-white shadow-sm">
                <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-4 text-right">
                <div className="rounded-lg bg-slate-100 p-2 text-slate-500"><FiPackage size={17} /></div>
                <h2 className="flex-1 text-sm font-semibold text-slate-700">زانیارییە پشتیوانەکان</h2>
                </div>
                <div className="grid grid-cols-1 divide-y divide-slate-50 sm:grid-cols-1 sm:divide-x sm:divide-y-0 sm:divide-x-reverse">
                    <Metric icon={FiDollarSign} label="بەهای کۆگا" value={money(initState?.summary_report_total_stock_price)} />
                </div>
            </section>
        </div>
    );
};

export default Summary_table;